import seLogoWhite from "../../assets/logos/SE_Logo_White.svg";
import seLogoColor from "../../assets/logos/SE_Logo_Color_RGB.svg";

export default function GlobalLogo({ className = "", themeMode = "dark" }) {
    const isLightMode = themeMode === "light";
    const logoSrc = isLightMode ? seLogoColor : seLogoWhite;

    return (
        <div className={`app-global-logo ${className}`.trim()} aria-hidden="true">
            <img
                className="app-global-logo__image"
                src={logoSrc}
                alt=""
            />
        </div>
    );
}
